/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

export function formatUTCDate(timestamp: number) : string {
  const date = new Date(timestamp);

  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC"
  }

  return new Intl.DateTimeFormat("en-US", options).format(date);
}

export function getTimeFromDate(date: Date | undefined) : number | undefined {
  if (!date) {
    return undefined;
  }
  return date.getTime();
}